// askAIDb.js — local IndexedDB store for Ask AI chat history & projects
const DB_NAME = 'aspiredeck_askai';
const DB_VERSION = 1;
const CHATS_STORE = 'chats';
const PROJECTS_STORE = 'projects';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(CHATS_STORE)) {
        const store = db.createObjectStore(CHATS_STORE, { keyPath: 'id' });
        store.createIndex('userId', 'userId', { unique: false });
      }
      if (!db.objectStoreNames.contains(PROJECTS_STORE)) {
        const store = db.createObjectStore(PROJECTS_STORE, { keyPath: 'id' });
        store.createIndex('userId', 'userId', { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function withStore(storeName, mode, fn) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, mode);
    const result = fn(tx.objectStore(storeName));
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
  });
}

export async function getAllChats(userId) {
  if (!userId) return [];
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const idx = db.transaction(CHATS_STORE, 'readonly').objectStore(CHATS_STORE).index('userId');
    const req = idx.getAll(userId);
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
}

export async function saveChat(userId, chat) {
  if (!userId) return;
  await withStore(CHATS_STORE, 'readwrite', (store) => store.put({ ...chat, userId }));
}

export async function deleteChatDb(chatId) {
  await withStore(CHATS_STORE, 'readwrite', (store) => store.delete(chatId));
}

export async function getAllProjects(userId) {
  if (!userId) return [];
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const idx = db.transaction(PROJECTS_STORE, 'readonly').objectStore(PROJECTS_STORE).index('userId');
    const req = idx.getAll(userId);
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
}

export async function saveProjectDb(userId, project) {
  if (!userId) return;
  await withStore(PROJECTS_STORE, 'readwrite', (store) => store.put({ ...project, userId }));
}

export async function deleteProjectDb(projectId) {
  await withStore(PROJECTS_STORE, 'readwrite', (store) => store.delete(projectId));
}